import React from 'react'
import styled from 'react-emotion'
import Img from 'gatsby-image'

export const BackgroundContainer = styled.div`
  bottom: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;

  .gatsby-image-outer-wrapper {
    height: 100%;
  }
`

export const BackgroundImage = styled(Img)`
  left: 50%;
  min-height: 100%;
  min-width: 1440px;
  transform: translate(-50%, 0);
`



// WEBPACK FOOTER //
// ./src/components/Background/index.js